import React from 'react';

const NameFields = ({ formData, handleInputChange }) => {
  return (
    <div className="form-group inline">
      <div>
        <label htmlFor="first-name">Vorname</label>
        <input type="text" id="first-name" name="firstName" value={formData.firstName} onChange={handleInputChange} required />
      </div>
      <div>
        <label htmlFor="last-name">Nachname</label>
        <input type="text" id="last-name" name="lastName" value={formData.lastName} onChange={handleInputChange} required />
      </div>
    </div>
  );
};

export default NameFields;
